import type { FinancialBookingPeriod, FinancialLedgerEntry } from '@/types/Models/Financial'
import { financialLedgerFilter, financialShipmentCarriers } from '@/services/FinancialLedger'

export const financialBookingEntries = (entries: FinancialLedgerEntry[], period: FinancialBookingPeriod): FinancialLedgerEntry[] =>
  financialLedgerFilter(entries, { from: period.from, to: period.to, carrier: 'all', customerId: 'all', status: 'all', search: '' })
    .filter((entry) => financialShipmentCarriers(entry.shipment).some((carrier) => period.carriers.includes(carrier)))
